import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="hero-cta"
// The hero renders outside the tracklist's queue-source scope (it's a
// layout content_for block), so the unlocked "Begin listening" pill hands
// playback off via a window event the tracklist subscribes to with
// data-action="hero-cta:begin@window->queue-source#playAll".
export default class extends Controller {
  begin() {
    window.dispatchEvent(new CustomEvent("hero-cta:begin"))
  }
}
